import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { TvControllerGroup } from '@/lib/schema/tvControllerGroup';
import { QRCodeCanvas } from 'qrcode.react';
import { useRef } from 'react';

type GroupQrDialogProps = {
  group: TvControllerGroup | null;
  onOpenChange: (open: boolean) => void;
};

export function GroupQrDialog({ group, onOpenChange }: GroupQrDialogProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  // The stored code is what the mobile app matches against.
  const code = group?.code ?? '';

  const download = () => {
    if (!canvasRef.current || !group) return;
    const link = document.createElement('a');
    link.href = canvasRef.current.toDataURL('image/png');
    link.download = `${code}.png`;
    link.click();
  };

  return (
    <Dialog open={!!group} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[380px]">
        <DialogHeader>
          <DialogTitle>{group?.name}</DialogTitle>
          <DialogDescription>
            The code changes every day at 3:00 AM (New York time) and when the
            group is renamed.
          </DialogDescription>
        </DialogHeader>
        {group && (
          <div className="flex flex-col items-center gap-3">
            {/* White backing so the code scans in dark mode too. */}
            <div className="rounded-md bg-white p-3">
              <QRCodeCanvas
                ref={canvasRef}
                value={code}
                size={256}
                level="M"
                marginSize={2}
              />
            </div>
            <span className="font-mono text-lg">{code}</span>
          </div>
        )}
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Close
          </Button>
          <Button type="button" onClick={download}>
            Download PNG
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
